import { createApiSaga } from '../../../sagaGenerator';
import {
  apiGet, apiPost, apiPut,
} from '../../../../middleware/api';
import {
  GET_EDIT_TSUNAMI_REQUEST,
  GET_EDIT_TSUNAMI_SUCCESS,
  GET_EDIT_TSUNAMI_FAILURE,
  UPDATE_EDIT_TSUNAMI_REQUEST,
  UPDATE_EDIT_TSUNAMI_SUCCESS,
  UPDATE_EDIT_TSUNAMI_FAILURE,
  CREATE_EDIT_TSUNAMI_REQUEST,
  CREATE_EDIT_TSUNAMI_SUCCESS,
  CREATE_EDIT_TSUNAMI_FAILURE,
  EDIT_TSUNAMI_VOLCANO_REQUEST,
  EDIT_TSUNAMI_VOLCANO_SUCCESS,
  EDIT_TSUNAMI_VOLCANO_FAILURE,
  EDIT_TSUNAMI_VOLCANO_SEARCH_REQUEST,
  EDIT_TSUNAMI_VOLCANO_SEARCH_SUCCESS,
  EDIT_TSUNAMI_VOLCANO_SEARCH_FAILURE,
  EDIT_TSUNAMI_EARTHQUAKE_REQUEST,
  EDIT_TSUNAMI_EARTHQUAKE_SUCCESS,
  EDIT_TSUNAMI_EARTHQUAKE_FAILURE,
  EDIT_TSUNAMI_EARTHQUAKE_SEARCH_REQUEST,
  EDIT_TSUNAMI_EARTHQUAKE_SEARCH_SUCCESS,
  EDIT_TSUNAMI_EARTHQUAKE_SEARCH_FAILURE,
  EDIT_TSUNAMI_REFERENCE_REQUEST,
  EDIT_TSUNAMI_REFERENCE_SUCCESS,
  EDIT_TSUNAMI_REFERENCE_FAILURE,
  EDIT_TSUNAMI_REFERENCE_SEARCH_REQUEST,
  EDIT_TSUNAMI_REFERENCE_SEARCH_SUCCESS,
  EDIT_TSUNAMI_REFERENCE_SEARCH_FAILURE,
  EDIT_TSUNAMI_WARNING_STATUS_REQUEST,
  EDIT_TSUNAMI_VALIDITY_REQUEST,
  EDIT_TSUNAMI_REGION_REQUEST,
  EDIT_TSUNAMI_LOCATION_REQUEST,
  EDIT_TSUNAMI_COUNTRY_REQUEST,
  EDIT_TSUNAMI_CAUSE_REQUEST,
  EDIT_TSUNAMI_AREA_REQUEST,
  EDIT_TSUNAMI_WARNING_STATUS_FAILURE,
  EDIT_TSUNAMI_WARNING_STATUS_SUCCESS,
  EDIT_TSUNAMI_CAUSE_FAILURE,
  EDIT_TSUNAMI_CAUSE_SUCCESS,
  EDIT_TSUNAMI_VALIDITY_FAILURE,
  EDIT_TSUNAMI_VALIDITY_SUCCESS,
  EDIT_TSUNAMI_LOCATION_FAILURE,
  EDIT_TSUNAMI_LOCATION_SUCCESS,
  EDIT_TSUNAMI_AREA_FAILURE,
  EDIT_TSUNAMI_AREA_SUCCESS,
  EDIT_TSUNAMI_COUNTRY_FAILURE,
  EDIT_TSUNAMI_COUNTRY_SUCCESS,
  EDIT_TSUNAMI_REGION_FAILURE,
  EDIT_TSUNAMI_REGION_SUCCESS,
} from './tsunamiEventEditReducer';

const getTsunamiSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/tsunamis/events/${action.id}`, ...action }),
  requestType: GET_EDIT_TSUNAMI_REQUEST,
  successType: GET_EDIT_TSUNAMI_SUCCESS,
  failureType: GET_EDIT_TSUNAMI_FAILURE,
});

const createTsunamiSaga = createApiSaga({
  apiFunction: apiPost,
  generateApiConfig: action => ({ endpoint: '/tsunamis/events', ...action }),
  requestType: CREATE_EDIT_TSUNAMI_REQUEST,
  successType: CREATE_EDIT_TSUNAMI_SUCCESS,
  failureType: CREATE_EDIT_TSUNAMI_FAILURE,
  successMessage: 'Saved',
});

const updateTsunamiSaga = createApiSaga({
  apiFunction: apiPut,
  generateApiConfig: action => ({ endpoint: `/tsunamis/events/${action.id}`, ...action }),
  requestType: UPDATE_EDIT_TSUNAMI_REQUEST,
  successType: UPDATE_EDIT_TSUNAMI_SUCCESS,
  failureType: UPDATE_EDIT_TSUNAMI_FAILURE,
  successMessage: 'Saved',
});

const getVolcanoSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/tsunamis/events/${action.id}/volcanoes`, ...action }),
  requestType: EDIT_TSUNAMI_VOLCANO_REQUEST,
  successType: EDIT_TSUNAMI_VOLCANO_SUCCESS,
  failureType: EDIT_TSUNAMI_VOLCANO_FAILURE,
});

const searchVolcanoesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/volcanoes', ...action }),
  requestType: EDIT_TSUNAMI_VOLCANO_SEARCH_REQUEST,
  successType: EDIT_TSUNAMI_VOLCANO_SEARCH_SUCCESS,
  failureType: EDIT_TSUNAMI_VOLCANO_SEARCH_FAILURE,
});


const getEarthquakeSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/tsunamis/events/${action.id}/earthquakes`, ...action }),
  requestType: EDIT_TSUNAMI_EARTHQUAKE_REQUEST,
  successType: EDIT_TSUNAMI_EARTHQUAKE_SUCCESS,
  failureType: EDIT_TSUNAMI_EARTHQUAKE_FAILURE,
});

const searchEarthquakesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/earthquakes', ...action }),
  requestType: EDIT_TSUNAMI_EARTHQUAKE_SEARCH_REQUEST,
  successType: EDIT_TSUNAMI_EARTHQUAKE_SEARCH_SUCCESS,
  failureType: EDIT_TSUNAMI_EARTHQUAKE_SEARCH_FAILURE,
});

const getReferencesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/tsunamis/events/${action.id}/references`, ...action }),
  requestType: EDIT_TSUNAMI_REFERENCE_REQUEST,
  successType: EDIT_TSUNAMI_REFERENCE_SUCCESS,
  failureType: EDIT_TSUNAMI_REFERENCE_FAILURE,
});

const searchReferencesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/references', ...action }),
  requestType: EDIT_TSUNAMI_REFERENCE_SEARCH_REQUEST,
  successType: EDIT_TSUNAMI_REFERENCE_SEARCH_SUCCESS,
  failureType: EDIT_TSUNAMI_REFERENCE_SEARCH_FAILURE,
});


const getRegionsSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/regions', ...action }),
  requestType: EDIT_TSUNAMI_REGION_REQUEST,
  successType: EDIT_TSUNAMI_REGION_SUCCESS,
  failureType: EDIT_TSUNAMI_REGION_FAILURE,
});

const getCountriesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/countries', ...action }),
  requestType: EDIT_TSUNAMI_COUNTRY_REQUEST,
  successType: EDIT_TSUNAMI_COUNTRY_SUCCESS,
  failureType: EDIT_TSUNAMI_COUNTRY_FAILURE,
});

const getAreasSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/areas', ...action }),
  requestType: EDIT_TSUNAMI_AREA_REQUEST,
  successType: EDIT_TSUNAMI_AREA_SUCCESS,
  failureType: EDIT_TSUNAMI_AREA_FAILURE,
});

const getWarningStatusSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/warning-statuses', ...action }),
  requestType: EDIT_TSUNAMI_WARNING_STATUS_REQUEST,
  successType: EDIT_TSUNAMI_WARNING_STATUS_SUCCESS,
  failureType: EDIT_TSUNAMI_WARNING_STATUS_FAILURE,
});

const getValiditySaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/validity', ...action }),
  requestType: EDIT_TSUNAMI_VALIDITY_REQUEST,
  successType: EDIT_TSUNAMI_VALIDITY_SUCCESS,
  failureType: EDIT_TSUNAMI_VALIDITY_FAILURE,
});

const getLocationSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/locations', ...action }),
  requestType: EDIT_TSUNAMI_LOCATION_REQUEST,
  successType: EDIT_TSUNAMI_LOCATION_SUCCESS,
  failureType: EDIT_TSUNAMI_LOCATION_FAILURE,
});

const getCauseSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/causes', ...action }),
  requestType: EDIT_TSUNAMI_CAUSE_REQUEST,
  successType: EDIT_TSUNAMI_CAUSE_SUCCESS,
  failureType: EDIT_TSUNAMI_CAUSE_FAILURE,
});

export const tsunamiEventEditSagas = [
  getTsunamiSaga,
  createTsunamiSaga,
  updateTsunamiSaga,
  getVolcanoSaga,
  searchVolcanoesSaga,
  getEarthquakeSaga,
  searchEarthquakesSaga,
  getReferencesSaga,
  searchReferencesSaga,
  getRegionsSaga,
  getCountriesSaga,
  getAreasSaga,
  getWarningStatusSaga,
  getValiditySaga,
  getLocationSaga,
  getCauseSaga,
];
